import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import NotesHeader from 'src/components/Notes/NotesHeader';
import {
  hasDeleteNoteIcon,
  hasEditableNotesRole,
  hbh1556RideHealthLinkMapping,
} from 'common/utils/FeatureFlags/flags';
import NotesCollection from './components/NotesCollection';
import NotesFooter from './components/NotesFooter';
import usePreparedNotes from './hooks/usePreparedNotes';

const Notes = ({
  currentEmployeeId,
  onAddNote,
  subject,
  subjectType,
  providerId,
  reason,
  editable,
  durations,
  showDeleteNoteIcon,
  showEditNoteIcon,
  reworkedAddNotes,
  notesTitle,
  notesContainerId,
  isClientsDrawer,
  rideHealthLinkMapping,
  compactBottomSpacing,
}) => {
  const [editingNoteId, setEditingNoteId] = useState(null);

  const {
    displayNotes,
    page,
    pageSize,
    paging,
    setPageNumber,
    setPageSize,
    isLoading,
    rideHealthConfig,
  } = usePreparedNotes({
    isClientsDrawer,
    rideHealthLinkMapping,
    providerId,
    subject,
    subjectType,
  });

  return (
    <div>
      {!reworkedAddNotes ? (
        <NotesHeader
          editable={editable}
          onAddNote={onAddNote}
          notesTitle={notesTitle}
        />
      ) : null}
      <NotesCollection
        currentEmployeeId={currentEmployeeId}
        displayNotes={displayNotes}
        durations={durations}
        editingNoteId={editingNoteId}
        isLoading={isLoading}
        notesContainerId={notesContainerId}
        onCancelEdit={() => setEditingNoteId(null)}
        onEdit={setEditingNoteId}
        reason={reason}
        rideHealthConfig={rideHealthConfig}
        showDeleteNoteIcon={showDeleteNoteIcon}
        showEditNoteIcon={showEditNoteIcon}
        subjectType={subjectType}
      />
      <NotesFooter
        compactBottomSpacing={compactBottomSpacing}
        isClientsDrawer={isClientsDrawer}
        page={page}
        pageSize={pageSize}
        paging={paging}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
      />
    </div>
  );
};

Notes.propTypes = {
  currentEmployeeId: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  subjectType: PropTypes.string.isRequired,
  providerId: PropTypes.string.isRequired,
  onAddNote: PropTypes.func.isRequired,
  reason: PropTypes.string,
  editable: PropTypes.bool,
  durations: PropTypes.array.isRequired,
  showDeleteNoteIcon: PropTypes.bool.isRequired,
  showEditNoteIcon: PropTypes.bool.isRequired,
  reworkedAddNotes: PropTypes.bool,
  notesTitle: PropTypes.string,
  notesContainerId: PropTypes.string,
  isClientsDrawer: PropTypes.bool,
  rideHealthLinkMapping: PropTypes.object,
  compactBottomSpacing: PropTypes.bool,
};

Notes.defaultProps = {
  reason: null,
  editable: true,
  reworkedAddNotes: false,
  notesTitle: 'Notes',
  notesContainerId: 'notes-container',
  isClientsDrawer: false,
  rideHealthLinkMapping: {},
  compactBottomSpacing: false,
};

const mapStateToProps = (state, ownProps) => ({
  onAddNote: ownProps.onAddNote,
  providerId: ownProps.providerId,
  subject: ownProps.subject,
  subjectType: ownProps.subjectType,
  durations: get(state, 'session.enums.time.duration', []),
  currentEmployeeId: get(state, 'globalState.currentEmployee.id', ''),
  showDeleteNoteIcon: hasDeleteNoteIcon(state),
  showEditNoteIcon: hasEditableNotesRole(state),
  rideHealthLinkMapping: hbh1556RideHealthLinkMapping(state),
});

export default connect(mapStateToProps)(Notes);
